import { Grid } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import type { GrupoArticulos } from '../../stores/grupos-articulos/grupo-articulos';
import type {
  ActualizarGrupoArticulos,
  RegistrarGrupoArticulos
} from '../../stores/grupos-articulos/grupos-articulos.store';
import { useUIStore } from '../../stores/ui/ui.store';
import type { CommonEntityFormProps } from '../../utils/common-entity-form-props';
import { getLengthOrErrorText } from '../../utils/get-length-or-error-text';
import AppTextField from '../ui/AppTextField';
import EditForm from '../ui/EditForm';

const validationSchema = yup.object({
  id: yup.string().required('La clave es requerida'),
  nombre: yup.string().required('El nombre es requerido')
});

type GrupoArticulosFormProps = {
  grupo?: GrupoArticulos;
  onSave:
    | ((values: ActualizarGrupoArticulos) => Promise<void>)
    | ((values: RegistrarGrupoArticulos) => Promise<boolean>);
} & CommonEntityFormProps;

const GrupoArticulosForm = ({ grupo, esAgregar, onSave, onDelete }: GrupoArticulosFormProps) => {
  const esEditar = !esAgregar;
  const { loading } = useUIStore((state) => state);
  const initialValues = {
    id: grupo?.id ?? 0,
    nombre: grupo?.nombre ?? ''
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      const success = await onSave(values);
      if (success) {
        formik.resetForm();
      }
    },
    enableReinitialize: true
  });

  const reset = () => formik.resetForm({ values: initialValues });

  return (
    <EditForm
      module="grupos-articulos"
      title="Grupo de Artículos"
      readonly={false}
      returnLink="/grupos-agrupaciones-articulos/grupos"
      loading={loading}
      showActivate={false}
      showDelete={esEditar}
      onSave={formik.handleSubmit}
      onClear={reset}
      onDelete={onDelete}
    >
      <Grid>
        <Grid container spacing={2}>
          <Grid>
            <AppTextField
              name="id"
              label="Clave"
              placeholder="Clave"
              value={formik.values.id}
              disabled={true}
            />
          </Grid>
          <Grid size="grow">
            <AppTextField
              name="nombre"
              label="Nombre"
              placeholder="Nombre"
              maxLength={40}
              disabled={loading}
              value={formik.values.nombre}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.nombre && Boolean(formik.errors.nombre)}
              helperText={getLengthOrErrorText(
                formik.touched.nombre ? formik.errors.nombre : '',
                formik.values.nombre.length,
                40
              )}
            />
          </Grid>
        </Grid>
      </Grid>
    </EditForm>
  );
};

export default GrupoArticulosForm;
